import { z } from "zod";

/** Funcionalidades que uma aplicação pode ligar ou desligar por configuração. */
export const featureKeys = ["agenda", "clients", "invoices", "finance", "reports", "settings"] as const;
export const featureKeySchema = z.enum(featureKeys);
export type FeatureKey = z.infer<typeof featureKeySchema>;

export const layoutSchema = z.enum(["sidebar", "topbar"]);
export type LayoutKind = z.infer<typeof layoutSchema>;

/** Configuração pública que o frontend recebe ao abrir, conforme o endereço acessado. Sem segredos. */
export const publicAppConfigSchema = z.object({
  id: z.string(),
  name: z.string(),
  shortName: z.string(),
  branding: z.object({ monogram: z.string(), tagline: z.string(), logoUrl: z.string().nullable(), faviconUrl: z.string().nullable() }),
  theme: z.record(z.string(), z.string()),
  layout: layoutSchema,
  features: z.array(featureKeySchema),
  settings: z.object({
    locale: z.string(),
    currency: z.string(),
    timezone: z.string(),
    terms: z.object({ client: z.object({ singular: z.string(), plural: z.string() }) }),
    appointmentTypes: z.array(z.string()),
    expenseCategories: z.array(z.string()),
    revenueSources: z.array(z.string()),
    nfseIssuer: z.string(),
  }),
});
export type PublicAppConfig = z.infer<typeof publicAppConfigSchema>;
